(function ($) {

	/*
	*  new_map
	*
	*  This function will render a Google Map onto the selected jQuery element
	*/

	function new_map($el) {

		// var
		var $markers = $el.find('.map__marker');

		// vars
		var args = {
			zoom: 16,
			center: new google.maps.LatLng(0, 0),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			styles: [
				{
					"featureType": "administrative",
					"elementType": "all",
					"stylers": [
						{
							"lightness": "-26"
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"lightness": "55"
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "labels",
					"stylers": [
						{
							"gamma": "1.82"
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#cda871"
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"color": "#ececec"
						}
					]
				},
				{
					"featureType": "administrative.locality",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "administrative.land_parcel",
					"elementType": "labels",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "all",
					"stylers": [
						{
							"color": "#ededed"
						}
					]
				},
				
				{
					"featureType": "poi",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry",
					"stylers": [

						{
							"saturation": "-50"
						},
						{
							"gamma": "1"
						},
						{
							"lightness": "0"
						},
						{
							"weight": "2"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "labels",
					"stylers": [
						{
							"visibility": "simplified"
						},
						{
							"hue": "#ffaa00"
						},
						{
							"saturation": "-70"
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "all",
					"stylers": [
						{
							"saturation": "-100"
						},
						{
							"lightness": "30"
						},
						{
							"visibility": "simplified"
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "all",
					"stylers": [
						{
							"saturation": "-100"
						},
						{
							"lightness": "40"
						},
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit.station.airport",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit.station.airport",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"gamma": "0.80"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#c9c9c9"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				}
			]
		};

		// create map
		var map = new google.maps.Map($el[0], args);

		// add a markers reference
		map.markers = [];

		// add markers
		$markers.each(function () {
			add_marker($(this), map);
		});

		// center map
		center_map(map);

		// return
		return map;

	}

	/*
	*  add_marker
	*
	*  This function will add a marker to the selected Google Map
	*/

	// Global variables
	var activeInfoWindow;

	function add_marker($marker, map) {

		// var
		var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

		var icon = {
			url: "/wp-content/themes/addhealthmedia/media/image/min/pin_marker.svg", // url
			scaledSize: new google.maps.Size(35, 35)
		};

		// create marker
		var marker = new google.maps.Marker({
			position: latlng,
			map: map,
			icon: icon,
		});

		// add to array
		map.markers.push(marker);

		// if marker contains HTML, add it to an infoWindow
		if ($marker.html()) {
			// create info window
			var infowindow = new google.maps.InfoWindow({
				content: $marker.html()
			});

			// show info window when marker is clicked
			google.maps.event.addListener(marker, 'click', function () {
				infowindow.open(map, marker);
			});

			// Show info window when marker is clicked, close info window on previous when a new marker on map is clicked.
			google.maps.event.addListener(marker, 'click', function () {
				if (activeInfoWindow) {
					activeInfoWindow.close();
				}
				infowindow.open(map, marker);
				activeInfoWindow = infowindow;
			});
		}

	}

	/*
	*  center_map
	*
	*  This function will center the map, showing all markers attached to this map
	*/

	function center_map(map) {

		// vars
		var bounds = new google.maps.LatLngBounds();

		// loop through all markers and create bounds
		$.each(map.markers, function (i, marker) {
			var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
			bounds.extend(latlng);
		});

		// only 1 marker
		if (map.markers.length == 1) {
			// set center of map
			map.setCenter(bounds.getCenter());
			map.setZoom(15);
		} else {
			// fit to bounds
			map.fitBounds(bounds);
			var listener = google.maps.event.addListener(map, "idle", function() { 
				map.setZoom(14); 
				google.maps.event.removeListener(listener); 
			});
		}

	}

	/*
	*  document ready
	*
	*  This function will render each map when the document is ready (page has loaded)
	*/

	// Global variables
	var map = null;

	$(document).ready(function () {

		// create map
		$('.map').each(function () {
			map = new_map($(this));
		});

		// Scroll and open Info window when click on address
		jQuery('.formContactUs__infoLinks--address').on('click', function (e) {
			e.preventDefault();

			var lat = parseFloat(jQuery(this).attr('data-lat'));
			var lng = parseFloat(jQuery(this).attr('data-lng'));
			var marker_id = jQuery(this).attr('data-marker-id');

			// Center map
			map.setCenter({
				lat: lat,
				lng: lng
			});
			map.setZoom(13);

			// Scroll top
			jQuery('html, body').animate({ scrollTop: 0 }, 'slow');

			// Toggle info window
			google.maps.event.trigger(map.markers[marker_id], 'click');
		});

	});

})(jQuery);
